import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { HttpService } from '../shared/services/http.service';

@Component({
    selector: 'app-manage-videos',
    templateUrl: './manage-videos.component.html',
    styleUrls: ['./manage-videos.component.scss'],
    standalone: false
})
export class ManageVideosComponent implements OnInit {

  videos: any[] = [];
  dataSource: any;

  displayedColumns = ['id', 'bunny_id', 'title', 'thumbnail', 'duration', 'actions'];

  video: any;

  videoFilter = '';
  filterDebounce: any;

  loading = false;
  skeletonRows: number[][] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private httpService: HttpService) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.videos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return ['id', 'bunny_id', 'title'].some(key =>
        (data[key] ?? '').toString().toLowerCase().includes(filter)
      );
    };

    this.fetchVideos();
  }

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchVideos() {
    this.loading = true;
    this.generateSkeletonRows();

    try {
      const response: any = await this.httpService.getAsync('hcontent/getVideos');
      this.videos = response?.data || [];
      this.dataSource.data = this.videos;
    } finally {
      this.loading = false;
    }
  }

  filter(event) {
    if (this.filterDebounce) {
      window.clearTimeout(this.filterDebounce);
    }

    this.filterDebounce = window.setTimeout(() => {
      this.videoFilter = event.target.value.trim();
      this.dataSource.filter = this.videoFilter.trim().toLowerCase();
    }, 250);
  }

  newVideo() {
    this.video = { id: '', bunny_id: '', title: '', thumbnail: '', duration: '' };
  }

  editVideo(row) {
    this.video = { ...row };
  }

  async closeVideoModal() {
    await this.fetchVideos();
    this.video = null;
  }

}
